export default {"src":"/_next/static/media/circle-check.9982e962.svg","height":640,"width":640,"blurWidth":0,"blurHeight":0};